import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { RequestChoasHistoryRowDataI, RequestHistoryRowDataI } from 'src/app/shared/constants/constants';
import { environment } from 'src/environments/environment';
import {ChaosManageResponse, WorkflowResponse} from 'src/app/shared/models/toast';
import {HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ChaosServiceService {

  private apiUrl=environment.apiUrl;
  deleteChaosRecord = new BehaviorSubject<any>(null);
  public selectedChoasRequestRow!: RequestChoasHistoryRowDataI;
  private selectedChoasResponseSubject: Subject<any> = new Subject<any>();
  private selectedRequestSubject: Subject<RequestChoasHistoryRowDataI> = new Subject();
  public selectedcardStartJob!: RequestChoasHistoryRowDataI;
  public deleteConfigRecord=new BehaviorSubject<any>(null);
  editManageConfiguration=new BehaviorSubject<any>(null);
  public deleteplaybookRecord=new BehaviorSubject<any>(null);
  editSelfHelpPlaybook=new BehaviorSubject<any>(null);
  private selfHelpUrl='http://172.171.160.120';
  public deleteWorflowRecord=new BehaviorSubject<any>(null);


  constructor(private http:HttpClient) { }


  public getChoasHistory(){
    let url=`${this.apiUrl}/ava/aipo/api/chaos/job/history`
    return this.http.get(url);
  }

  // public startJob(jobId:number,jobName:string,hostname:string,resource_group:string,initiatedBy:string,){
  //   let startUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/start?jobId=${jobId}&jobName=${jobName}&hostname=${hostname}&resource_group=${resource_group}&initiatedBy=${initiatedBy}`;
  //   return this.http.get(startUrl);
  // }

  public postJobStart(payload:any){
    // const url=`${this.apiUrl}/ava/aipo/api/v2/chaos/job/start`;
    const url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/start`;
    return this.http.post(url,payload)
  }

  public setSelectedstartJob(row: RequestChoasHistoryRowDataI) {
		this.selectedcardStartJob = row;
	}

	public getSelectedStartJob() {
		return this.selectedcardStartJob;
	}

  public deleteRecord(requestId:number){
    const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/delete?requestId=${requestId}`;
    return this.http.delete(apiUrl);   
  }

  public getSelectedhistory(requestId:number){
    const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/detail?requestId=${requestId}`;
    return this.http.get(apiUrl).pipe(
      map((response: any) => {
          return response;
      })
  );
  
  }

  public setSelectedTestDesignRow(row: RequestChoasHistoryRowDataI): Observable<any> | void {
    this.selectedChoasRequestRow = row;
    this.selectedRequestSubject.next(row);

    if (row) {
        this.getSelectedhistory(row.requestId).subscribe((res: any) => {
            this.selectedChoasResponseSubject.next(res);
        });
    }
}

public getSelectedRequest() {
  return this.selectedChoasRequestRow;
}

public getSelectedChoasResponse(): Observable<any> {
  return this.selectedChoasResponseSubject.asObservable();
}

public getLogReport(jobRunId:number){
  // let url=`${this.apiUrl}/ava/aipo/api/chaos/job/log?jobRunId=${jobRunId}`;
  let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/log?jobRunId=${jobRunId}`;
  return this.http.get(url)
}

public manageConfiguration(payload:any){
  let url=`${this.apiUrl}/ava/aipo/api/chaos/job/config`;
  return this.http.post(url,payload)
}

public choasManageHistoryData(): Observable<ChaosManageResponse> {
  const url = `${this.apiUrl}/ava/aipo/api/chaos/job/config/list`;
  return this.http.get<ChaosManageResponse>(url);
}

public deleteManageConfigRecord(jobId:number){
  const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/delete-config?jobId=${jobId}`;
  return this.http.delete(apiUrl);   
}

public updateManageConfiguration(jobId:any,payload:any){
  const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/edit-config?jobId=${jobId}`;
  return this.http.put(apiUrl,payload)
}

public getManageConfigDataById(jobId:any){
  const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/get-config?jobId=${jobId}`;
  return this.http.get(apiUrl)
}

public getSelfHelpecord(){
  const selfHelpUrl=`${this.apiUrl}/ava/aipo/accelerator/selfhelp/template/get`;
  return this.http.get(selfHelpUrl);
}

public deleteSelfHelpPlaybook(playbookId:number){
  const apiUrl=`${this.apiUrl}/ava/aipo/accelerator/selfhelp/template/delete?playbookId=${playbookId}`;
  return this.http.delete(apiUrl);   
}

public editSelfPlaybook(playbookId:any,payload:any){
  const apiUrl=`${this.apiUrl}/ava/aipo/accelerator/selfhelp/template/update?playbookId=${playbookId}`;
  return this.http.put(apiUrl,payload)
}

public submitSelfHelpPlaybook(payload:any){
  let url=`${this.apiUrl}/ava/aipo/accelerator/selfhelp/template/save`;
  return this.http.post(url,payload)
}

public playbooksData: any[] = [];

setPlaybooksData(data: any[]): void {
  this.playbooksData = data;
}

getPlaybooksData(): any[] {
  return this.playbooksData;
}

public onboardingSubmit(payload: any) {
  let url = `${this.selfHelpUrl}/api/v2/job_templates/148/launch/`;
  let headers = new HttpHeaders({
    'Authorization': `Bearer 3dVP8IKXmiQQDd6DKgPRh0OxnIhI6Q`,
    'Content-Type': 'application/json'
  });

  return this.http.post(url, payload, { headers });
}

public offboardingSubmit(payload: any) {
  let url = `${this.selfHelpUrl}/api/v2/job_templates/79/launch/`;
  let headers = new HttpHeaders({
    'Authorization': `Bearer 3dVP8IKXmiQQDd6DKgPRh0OxnIhI6Q`,
    'Content-Type': 'application/json'
  });

  return this.http.post(url, payload, { headers });
}

public resetPasswordSubmit(payload: any) {
  let url = `${this.selfHelpUrl}/api/v2/job_templates/147/launch/`;
  let headers = new HttpHeaders({
    'Authorization': `Bearer 3dVP8IKXmiQQDd6DKgPRh0OxnIhI6Q`,
    'Content-Type': 'application/json'
  });
  return this.http.post(url, payload, { headers });
}

// public createNewWorkflow(payload:any){
//   let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template-config`;
//   return this.http.post(url,payload)
// }

public createNewWorkflow(payload:any){
  // let url=`${this.apiUrl}/ava/aipo/api/v2/chaos/job/template-config`;
  let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/save`;
  return this.http.post(url,payload)
}

public getWorkflowHistoryList():Observable<WorkflowResponse>{
  // let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/list`;
    let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/get/all`;

  return this.http.get<WorkflowResponse>(url)
}

public getWorkflowById(workflowId:number){
  // let url=`${this.apiUrl}/ava/aipo/api/chaos/job/get-configtemplate?workflowId=${workflowId}`;
  let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/detail/get?workflowId=${workflowId}`;
  return this.http.get(url)
}

public deleteWorkFlow(workflowId:number){
  let url=`${this.apiUrl}/ava/aipo/api/chaos/job/template/delete?workflowId=${workflowId}`;
  return this.http.delete(url)
}

// public editWorkflowcardCreation(workflowId:number,payload:any){
//   const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/edit-configTemplate?workflowId=${workflowId}`;
//   return this.http.put(apiUrl,payload);
// }

public editWorkflowcardCreation(workflowId:number,payload:any){
  // const apiUrl=`${this.apiUrl}/ava/aipo/api/v2/chaos/job/edit-configTemplate?workflowId=${workflowId}`;
  const apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/template/edit?workflowId=${workflowId}`;
  return this.http.put(apiUrl,payload);
}

public createSettings(workflowId:number,payload:any){
  let apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/config/setting?workflowId=${workflowId}`;
  return this.http.post(apiUrl,payload)
}

// public getJobnameById(workflowId:number){
//   let apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/get-configtParam?workflowId=${workflowId}`;
//   return this.http.get(apiUrl)
// }

public getParamsnameById(workflowId:number){
  // let apiUrl=`${this.apiUrl}/ava/aipo/api/v2/chaos/job/get-configtParam?workflowId=${workflowId}`;
  let apiUrl=`${this.apiUrl}/ava/aipo/api/chaos/job/template/get?workflowId=${workflowId}`;
  return this.http.get(apiUrl)
}

public decommissionServiceSubmit(payload:any){
  let apiUrl=`${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/decommission`;
  return this.http.post(apiUrl,payload)
}

public getJobDetailsforSelfhelp(jobRunId:number){
  let url = `${this.apiUrl}/ava/aipo/accelerator/selfhelp/api/v1/job/details?jobRunId=${jobRunId}`;
  return this.http.get(url);
}

}
